/**
 * Document groups the third party sees (contracts/bucket-layout.md, R-04, amended
 * 2026-09-09 to the layout Phase 1 actually produces).
 *
 * The group is derived from the piece name at the end of each file name
 * (`{TIPO}_{noDoc}_{pieza}.ext`) or from the payroll file pattern; it is never a folder.
 */
export const TIPOS_DOCUMENTO = [
    { clave: 'facturas', nombre: 'Facturas', abrev: 'FAC', detalle: 'PDF · facturas de proveedores' },
    {
        clave: 'contratos',
        nombre: 'Contratos y otrosíes',
        abrev: 'CTO',
        detalle: 'PDF · vigentes en el periodo',
    },
    { clave: 'actas', nombre: 'Actas', abrev: 'ACTA', detalle: 'PDF · actas de obra y de reembolso' },
    {
        clave: 'causacion-contable',
        nombre: 'Causación contable',
        abrev: 'CAU',
        detalle: 'PDF · comprobante contable',
    },
    {
        clave: 'nomina',
        nombre: 'Comprobantes de nómina',
        abrev: 'NOM',
        detalle: 'PDF · personal del centro de costo',
    },
    {
        clave: 'anexos',
        nombre: 'Anexos y soportes',
        abrev: 'ANX',
        detalle: 'PDF y ZIP · adjuntos de cada documento',
    },
    { clave: 'otros', nombre: 'Otros documentos', abrev: 'OTR', detalle: 'Sin clasificar' },
];
export const CLAVES_TIPO_DOCUMENTO = TIPOS_DOCUMENTO.map((t) => t.clave);
export function esTipoDocumento(valor) {
    return CLAVES_TIPO_DOCUMENTO.includes(valor);
}
export function nombreTipoDocumento(clave) {
    const tipo = TIPOS_DOCUMENTO.find((t) => t.clave === clave);
    if (!tipo)
        throw new Error(`unknown document type: ${clave}`);
    return tipo.nombre;
}
/**
 * Sinco accounting document prefixes seen in Phase 1 uploads. Kept as data (not a folder) so
 * the third party can filter later if Coninsa asks; the portal groups by piece, not by this.
 */
export const PREFIJOS_COMPROBANTE = ['CP', 'DG', 'NA', 'NP', 'PM', 'CE', 'AJ'];
/** Maps the piece suffix of a file name to a group. Case and accent insensitive. */
export function tipoPorPieza(pieza) {
    const p = pieza.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    if (p.startsWith('factura'))
        return 'facturas';
    if (p.startsWith('contrato'))
        return 'contratos';
    if (p.startsWith('acta'))
        return 'actas';
    if (p.startsWith('causacion'))
        return 'causacion-contable';
    if (p.includes('nomina'))
        return 'nomina';
    if (p === '')
        return 'otros';
    return 'anexos';
}
//# sourceMappingURL=tipos-documento.js.map